import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';
import { NewDeletePinComponent } from '../new-delete-pin/new-delete-pin.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import dayjs from "dayjs";
import { PinManagerService } from 'src/app/services/pin-manager.service';
import { catchError, throwError } from 'rxjs';
import { yieldEstimationUnitOfmeasure } from 'src/app/models/yieldEstimationUnitOfMeasure';
import { yieldEstimationPin } from 'src/app/models/yieldEstimationPin';

interface Food {
  value: string;
  viewValue: string;
}

@Component({
    selector: 'app-yield-estimation-pin',
    templateUrl: './yield-estimation-pin.component.html',
    styleUrls: ['./yield-estimation-pin.component.css'],
    standalone: false
})
export class YieldEstimationPinComponent {

  updatePinForm: FormGroup;
  currentPin = null;
  dateStringFormatting = 'YYYY-MM-DD' + '  ' + 'hh:mm:ss'; 
  placeholder: string = "-";
  yieldEstimationDetails: yieldEstimationPin;

  unitOfMeasureList: yieldEstimationUnitOfmeasure[] = [];

  protected readonly dayjs = dayjs;

  pinObj = {
    pinTypeId: this.data.pinTypeId,
    date: this.data.date,
    lat: this.data.lat,
    lng: this.data.lng,
    farm: this.data.farm,
    field: this.data.field,
    fieldId: this.data.fieldId,
    creatingUser: this.data.creatingUser,
    pinId: this.data.pinId
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
       public closePinDialog: MatDialogRef<YieldEstimationPinComponent>,
       public nav: NavBarComponent,
       public deletePinDialog: MatDialog,
       private pinManagerService: PinManagerService,
  ) {
    this.closePinDialog.backdropClick().subscribe(() => {
      this.close();
    });
    
      this.updatePinForm = new FormGroup({
        pinDescription: new FormControl(null),
        unitOfMeasure: new FormControl(null),
        yieldEstimation: new FormControl(null),
        yieldWeightedValue: new FormControl(null),
        estimationDate: new FormControl(null),
      })
  }

  ngOnInit(): void {

    this.populateUnitOfMeasureListDropDown();

    if(this.data?.pinDescription !== null){
      this.updatePinForm.controls.pinDescription.setValue(this.data?.pinDescription);
    }

    if(this.data?.unitOfMeasureId == null){
      this.updatePinForm.controls.unitOfMeasure.setValue(2);
    }
    else{
      this.updatePinForm.controls.unitOfMeasure.setValue(this.data?.unitOfMeasureId);
    }

    if(this.data?.yieldEstimation !== null){
      this.updatePinForm.controls.yieldEstimation.setValue(this.data?.yieldEstimation);
    }
    

    if(this.data?.yieldWeightedValue !== null){
      this.updatePinForm.controls.yieldWeightedValue.setValue(this.data?.yieldWeightedValue);
    }

    if(this.data?.estimationDate !== null){
      this.updatePinForm.controls.estimationDate.setValue(this.data?.estimationDate);
    }
    

    this.nav.toggleLoading(false);
  }

    populateUnitOfMeasureListDropDown() {
      this.pinManagerService.getYieldestimationUnitOfmeasure().pipe(
              catchError((error) => {
                console.error(error);
                return throwError(() => error);
              })
          )
          .subscribe((response) => {
            this.unitOfMeasureList = response;



          });
    }


    updatePin() {
      this.nav.toggleLoading(true);
  
      let formattedDate = dayjs(this.updatePinForm.get('estimationDate')?.value).format('YYYY-MM-DD');
   
      let yieldestPinObj = {
        pinId: Number(this.pinObj?.pinId),
        description: this.updatePinForm.get('pinDescription')?.value,
        unitOfMeasureId: Number(this.updatePinForm.get('unitOfMeasure')?.value),
        yieldEstimation: Number(this.updatePinForm.get('yieldEstimation')?.value),
        yieldWeightedValue: Number(this.updatePinForm.get('yieldWeightedValue')?.value),
        estimationDate: formattedDate,
      };

      this.pinManagerService.updateYieldEstimationPinById(yieldestPinObj?.pinId, yieldestPinObj?.description, yieldestPinObj?.unitOfMeasureId, yieldestPinObj?.yieldEstimation, yieldestPinObj?.yieldWeightedValue, yieldestPinObj?.estimationDate).pipe(
        catchError(error => {
          console.error(error);
          return throwError(() => error);
        })
      ).subscribe(() => {
        this.closePinDialog.close(this.pinObj);
      });
    }


  close(): void {
    this.closePinDialog.close(this.pinObj);
  }

    openDeletePinDialog() {
  
      const dialogRef = this.deletePinDialog.open(NewDeletePinComponent, {
        data: {
          pinId: this.pinObj.pinId
        }
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if(result.option === 'delete'){
          this.closePinDialog.close();
         }
      });
    }
}
